import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
} from "reactstrap";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Placeholder from "../../../assets/images/Placeholder.gif";
import moreIcon from "../../../assets/images/more.png";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useSelector } from "react-redux";

const IndividualGymRatings = () => {
  document.title = "Gym Ratings | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId") || null;

  const [dropdownOpen, setDropdownOpen] = useState({
    selectGym: false,
    dateRange: false,
    byLocation: false,
    mostLoved: false,
  });
  const [passesData, setPassesData] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [endSearchDate, setEndSearchDate] = useState("");
  const itemsPerPage = 6;
  const [startSearchDate, setStartSearchDate] = useState("");
  const { currentUser } = useSelector((state) => state.auth);

  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState(gymId);
  const [selectedIndex, setSelectedIndex] = useState();
  const [rating, setRating] = useState([]);
  const toggleDropdown = (passId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [passId]: !prevState[passId],
    }));
  };
  const fetchPasses = async (page) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.gymSingleRatings}${gymId}?limit=${6}&page=${page}`
      );

      const gyms = response?.data?.data || [];
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
      setGymData(gyms);
    } catch (error) {
      console.error("Error fetching gym data:", error);
      setPassesData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPasses(currentPage);
  }, [gymId, currentPage]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const navigate = useNavigate();

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-center mb-3">
                  {/* Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      {`${gymData[0]?.gymId?.name} Gym Ratings`}
                    </span>
                  </div>
                  <div className="d-flex flex-column flex-xl-row gap-2 w-100 mt-2 mt-xl-0"></div>
                </div>

                <div
                  className="table-responsive hide-scrollbar rounded-4"
                  style={{
                    height: gymData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless ff-sora table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>User Name</th>
                        <th>Rating</th>
                        <th>Review</th>
                        <th>Organization & Cleanliness</th>
                        <th>Vibe & Uniqueness</th>
                        <th>Equipment Curation</th>
                        <th>Accessibility & Crowd Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : gymData.length === 0 ? (
                        <></>
                      ) : (
                        gymData.map((pass, index) => (
                          <tr key={pass.id}>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>

                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {`${
                                pass?.userId?.firstName != null
                                  ? pass?.userId?.firstName
                                  : ""
                              } ${
                                pass?.userId?.lastName != null
                                  ? pass?.userId?.lastName
                                  : ""
                              }`}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.rating == "NaN"
                                ? "0"
                                : parseFloat(pass.rating).toFixed(1)}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.review == "" ? "No Comment" : pass?.review}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.generalExperience
                                ? parseFloat(pass.generalExperience).toFixed(1)
                                : "0"}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.service
                                ? parseFloat(pass.service).toFixed(1)
                                : "0"}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.facilityQuality
                                ? parseFloat(pass.facilityQuality).toFixed(1)
                                : "0"}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {pass?.accessibilityConvenience
                                ? parseFloat(
                                    pass.accessibilityConvenience
                                  ).toFixed(1)
                                : "0"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && gymData.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="mt-3 ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default IndividualGymRatings;
